module.exports = __webpack_public_path__ + "assets/img/26.18fcc4ed.png";